import apiClient from '.';

const getFilters = async (filterApi: any, params?: Record<string, string>) => {
    try {
        const { data } = await apiClient.get(filterApi, {
            queryParams: { ...params },
        });
        return data;
    } catch (e: any) {
        return { error: e?.response?.data?.error };
    }
};

const getHoldingsFilters = async (params: any) => {
    try {
        const { data } = await apiClient.get('filters/holdings', {
            queryParams: { ...params },
        });
        return data;
    } catch (e: any) {
        return { error: e?.response?.data?.error };
    }
};

export { getHoldingsFilters, getFilters };
